import { Node } from '../metadata';

function checkDuplicatedUUIDS(root: Node): void {
  const uuids = new Set();

  function transverseMetadataTree(node: Node): void {
    const { uuid } = node.props;

    if (!uuids.has(uuid)) {
      uuids.add(uuid);
    } else {
      throw new Error(`[TWS-ENGINE]: Found duplicated UUID: ${uuid}`);
    }

    if (node.children) {
      node.children.forEach(transverseMetadataTree);
    }
  }

  transverseMetadataTree(root);
}

export default checkDuplicatedUUIDS;
